
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./app": () => {
return Promise.all(/*  | __federation_expose_app */ [__webpack_require__.e("9594"), __webpack_require__.e("4102"), __webpack_require__.e("9612"), __webpack_require__.e("6934"), __webpack_require__.e("916"), __webpack_require__.e("7194")]).then(() => (() => (__webpack_require__(82472))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };